import type { BuildingInteriorSpec } from "@cold-case/shared/interior-layout";
import { TILE_SIZE } from "@cold-case/shared/constants";

import { tileToWorldCenter } from "./interior-exit-world.js";

const INTERIOR_PATROL_MIN_DIST_PX = TILE_SIZE * 2.2;
const FILLER_INTERIOR_PATROL_MIN_DIST_PX = TILE_SIZE * 1.4;

/** Random walkable world point inside an interior (for building-tied NPC patrol). */
export function pickInteriorPatrolTarget(
  spec: BuildingInteriorSpec,
  fromWx: number,
  fromWy: number,
  opts?: { filler?: boolean; rng?: () => number }
): { x: number; y: number } | null {
  const rand = opts?.rng ?? Math.random;
  const minDist = opts?.filler ? FILLER_INTERIOR_PATROL_MIN_DIST_PX : INTERIOR_PATROL_MIN_DIST_PX;
  const maxAttempts = opts?.filler ? 20 : 14;
  const candidates: { x: number; y: number }[] = [];
  for (let ty = 0; ty < spec.gridH; ty++) {
    for (let tx = 0; tx < spec.gridW; tx++) {
      if (!spec.walkable[ty]![tx]) continue;
      const { wx, wy } = tileToWorldCenter(tx, ty);
      candidates.push({ x: wx, y: wy });
    }
  }
  if (candidates.length === 0) return null;

  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    const c = candidates[Math.floor(rand() * candidates.length)]!;
    if (Math.hypot(c.x - fromWx, c.y - fromWy) >= minDist) {
      return c;
    }
  }
  return candidates[Math.floor(rand() * candidates.length)] ?? null;
}
